import React from "react";
import { Button } from "~components";
import cn from "classnames";
import { useCartContext, useProductContext, useAppContext } from "~hooks";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Used to upsell a product on PDP
 *
 * @param 	{string}  			productId					Product ID
 * @param 	{string}  			pdpProductId			Product ID of PDP page product
 * @param 	{string}  			className 				For additional styling config
 * @return	{node}
 */

const PdpUpsell = ({ productId, pdpProductId, className }) => {
  const {
    setCartUpsellProductIds,
    setIsCartUpsellWindowOpen,
    numberOfItemsInCart,
    getCartDiscountPercentage
  } = useCartContext();
  const { setIsCartOpen } = useAppContext();
  const { getProductData } = useProductContext();

  const { title, shortDescription, productPageImages, price } =
    getProductData(productId) || {};

  const handleClick = () => {
    setIsCartOpen(true);
    setCartUpsellProductIds([pdpProductId, productId]);
    setIsCartUpsellWindowOpen(true);
  };

  const image = productPageImages?.[0];

  const nextTierDiscountPercentage = getCartDiscountPercentage(
    numberOfItemsInCart + 2
  );
  const preDiscountPrice = price.amount;
  const discountPrice =
    preDiscountPrice - preDiscountPrice * (nextTierDiscountPercentage / 100);

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.imageContainer}>
        {image && (
          <GatsbyImage image={image.asset.gatsbyImageData} alt={title || ``} />
        )}
      </div>
      <div className={styles.textContainer}>
        <div>
          <h3 className={cn(`h4`)}>{title}</h3>
          <div className={cn(`h4`, styles.price)}>
            ${discountPrice.toFixed(2)}
            {` `}
            <span className={styles.strikethrough}>
              ${preDiscountPrice.toFixed(2)}
            </span>
          </div>
          <p className={cn(`b2`, styles.description)}>{shortDescription}</p>
        </div>
        <Button onClick={handleClick} variant="secondary" fluid>
          Choose
        </Button>
      </div>
    </div>
  );
};

export default PdpUpsell;
